import { defineStore } from 'pinia'
import { useSyncableModel } from '@/composables/useSyncableModel.js'
import { useApiResource } from '@/composables/resources/useApiResource.js'
import AgriHarvest from '@/models/AgriHarvest.js'

export const useAgriHarvestStore = defineStore('agriHarvestStore', () => {
  let syncableModel = useSyncableModel(useApiResource('agri_harvests'), {
    className: AgriHarvest.modelName.name,
    paramKey: AgriHarvest.modelName.paramKey
  })

  function $reset() {
    syncableModel.collection.value = []
  }

  return {
    ...syncableModel,
    $reset
  }

}, {
  persist: true
})

